import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";


const ProductSearchBar = ({ products = [], onProductSelect, onClose }) => {
  const [query, setQuery] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!products || query.trim().length < 2) {
      setFilteredProducts([]);
      return;
    }

    const lowerQuery = query.toLowerCase();
    const results = products.filter((product) => {
      const productName = product.name?.toLowerCase() || "";
      const productCode = product.code?.toLowerCase() || "";
      return productName.includes(lowerQuery) || productCode.includes(lowerQuery);
    });

    setFilteredProducts(results);
  }, [query, products]);

  const handleProductClick = (product) => {
    navigate(`/products/${product.slug}/`);
    onClose?.(); // close the search on select
  };

  return (
    <div className="w-full relative">
      <div className="relative">
        <input
          type="text"
          className="w-full p-3 pr-10 border border-gray-300 rounded-lg bg-[#fefcfc] placeholder-gray-500 text-gray-800"
          placeholder="Search products by name & code"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      
      </div>

      {filteredProducts.length > 0 && (
        <ul className="mt-2 bg-white border rounded shadow max-h-60 overflow-y-auto">
          {filteredProducts.map((product) => (
            <li
              key={product.id}
              className="p-2 hover:bg-gray-100 cursor-pointer"
              onClick={() => handleProductClick(product)}
            >
              {product.name} {product.code}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ProductSearchBar;
